import { createAction } from "redux-actions";
import {
  CLEAR_LANDING_PAGE_DATA,
  UPDATE_BANNERS,
  UPDATE_CONTACT_DATA,
  UPDATE_DEALER,
  UPDATE_FORM_DETAILS,
  UPDATE_LANDING_PAGE_DATA,
  UPDATE_LEAD_VERIFICATION,
  UPDATE_LISTING,
  UPDATE_LOCATION,
  UPDATE_NO_REDIRECT,
  UPDATE_OEM_SERVICEABLE_POPUP,
  UPDATE_SEARCH,
  UPDATE_SERVICEABLE_LIST,
  UPDATE_SERVICEABLE_POPUP,
  UPDATE_VIDEO,
  UPDATE_WEB_SUCCESS,
  UPDATE_WIDGET,
} from "./type";

export const updateLocation = createAction(UPDATE_LOCATION);
export const updateLandingPageData = createAction(UPDATE_LANDING_PAGE_DATA);
export const updateWidget = createAction(UPDATE_WIDGET);
export const updateSearch = createAction(UPDATE_SEARCH);
export const updateListing = createAction(UPDATE_LISTING);
export const clearLandingPageData = createAction(CLEAR_LANDING_PAGE_DATA);
export const updateServiceableList = createAction(UPDATE_SERVICEABLE_LIST);
export const updateServiceablePopup = createAction(UPDATE_SERVICEABLE_POPUP);
export const updateFormDetails = createAction(UPDATE_FORM_DETAILS);
export const updateDealer = createAction(UPDATE_DEALER);
export const updateServiceableOemPopup = createAction(
  UPDATE_OEM_SERVICEABLE_POPUP
);
export const updateNoRedirect = createAction(UPDATE_NO_REDIRECT);
export const updateWebSuccess = createAction(UPDATE_WEB_SUCCESS);
export const updateContactData = createAction(UPDATE_CONTACT_DATA);
export const updateLeadVerification = createAction(UPDATE_LEAD_VERIFICATION);
export const updateBanners = createAction(UPDATE_BANNERS);
export const updateVideo = createAction(UPDATE_VIDEO);
